export const APP_STATUS_UPDATE = 'APP_STATUS_UPDATE'
export const APP_CONFIG_UPDATE = 'APP_CONFIG_UPDATE'
